module.exports = __webpack_public_path__ + "img/app_apple.616f9ca9.png";